import React from 'react';

const Ltifr = () => {
  return (
    <div className="key-statics">
      <div className="first-title">
        <h5>0.67</h5>
        <p>
          LTIFR <br />
          (FY2019: 0.49)
        </p>
      </div>
      <h5>7</h5>
      <p>Fatalities (FY2019: 9)</p>
    </div>
  );
};

export default Ltifr;
